import React, { useContext, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PerfectScrollbar from 'react-perfect-scrollbar';
// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';
import CardItem from './CardItem';
import { Context } from './ContextWrapper';
import { fetchProductIdentifier, fetchProductIdentifierType } from '../Store/SystemMasters.action';

function CardContent() {
  const { cards } = useContext(Context);
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const csList = useSelector((state) => state);
  const {
    UserDetails: { userInfo },
  } = csList;

  useEffect(() => {
    if (userInfo.userId) {
      dispatch(fetchProductIdentifierType(t));
      dispatch(fetchProductIdentifier(t));
    }
  }, [dispatch, userInfo]);

  return (
    <PerfectScrollbar>
      <ul>
        {cards.map((card, index) => (
          <CardItem key={card?._id || index} index={index} item={card} />
        ))}
      </ul>
    </PerfectScrollbar>
  );
}

export default CardContent;
